<template>
  <div v-show='cpntMostrar' class="rf-input-group" :class='cpntClassDivField'>
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='status !== ""'>
      <RF-Status :cpntStatus='status' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else>
      <textarea 
        :id='cpntId' 
        :class='classCampo'
        :autocomplete='cpntAutoComplete'
        :disabled='cpntDisabled'
        :tabIndex='cpntTabIndex'
        :maxlength="cpntMaxLength"
        :placeholder="cpntPlaceholder"

        v-model='value'
        :ref='cpntId' 
      ></textarea>

      <span class="rf-barra"></span>
      <label :for='cpntId' :class='"has-" + cpntMensagemTipo'>
        <span v-html='cpntNome'></span>

        <RF-Explica v-if='[ "", null, undefined ].indexOf(cpntExplica) === -1 && Object.keys(cpntExplica).length >= 1'
          :cpntId='cpntId + "-explica"' 
          :cpntTitle='cpntExplica.mensagem'
          :cpntPositionMy='cpntExplica.posicaoMy'
          :cpntPositionAt='cpntExplica.posicaoAt'
          :cpntClasses='cpntExplica.class'

          style='vertical-align: 0px;'
        ></RF-Explica>
      </label>
      <span v-if='cpntMensagem !== "" && cpntMensagem !== null' v-html='cpntMensagem' :class='"has-" + cpntMensagemTipo'></span>
    </template>
  </div>
</template>

<style scoped>
/* -=-=-=-=-=-= ESTILO INICIAL =-=-=-=-=-=- */
.rf-input-group {
  position: relative;
  margin-bottom: 30px;
}

/* ------------------ CONFIGURA O INPUT ------------------ */
.rf-input-group > textarea {
  display: block;
  width: 100%;
  border: none;
  border: 1px solid #CCC;
  padding: 5px 5px 5px 5px;
  color: #292b2c;

  min-height: 70px;
 }
  /* ------------------ REMOVE BORDAS INPUT QUANDO DA FOCUS ------------------ */
  .rf-input-group > textarea:focus { 
    outline: none; 
  }

/* ------------------ MODO DE ABERTURA DA ANIMAÇÃO ------------------ */
.rf-input-group > textarea:focus ~ .rf-barra:before, .rf-input-group > textarea:focus ~ .rf-barra:after {
  width: 50%;
}
.rf-barra:before { 
  left: 50%;
}
.rf-barra:after {
  right: 50%;
}
/* ------------------ APRESENTA A BARRA ABAIXO DO INPUT QUANDO SELECIONADO ------------------ */
.rf-barra {
  position: relative;
  display: block;
  width: 100%;
 }
.rf-barra:before, .rf-barra:after {
  position: absolute;
  bottom: 1px;
  content: '';
  width: 0px;
  height: 2px;
  background: #4285f4;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
 }
/* ------------------ TITULO DO CAMPO ------------------ */
.rf-input-group > label {
  position: absolute;
  left: 0px;
  top: -20px;
  color: var(--color-base-02);
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
 }   
  /* ------------------ LOCAL E COR QUE FICA O TITULO DO CAMPO APÓS PREENCHIDO ------------------ */
  .rf-input-group > textarea:focus ~ label, .rf-input-group > textarea.rf-input-focus-true ~ label {
    left: 0px;
    top: -20px;
  }
  .rf-input-group > textarea:focus ~ label {
    color: #4285f4;
  }
  /* ------------------ ALTERA A COR CASO NÃO SEJA VALIDADO ------------------ */
    .rf-input-group > textarea.has-error ~ label {
      top: -20px;
      color: #a94442;
    }
    .rf-input-group > textarea.has-error ~ .rf-barra:before, .rf-input-group > textarea.has-error ~ .rf-barra:after {
      position: absolute;
      bottom: 1px;
      content: '';
      width: 0px;
      height: 2px;
      background: #a94442;
      transition: 0.2s ease all;
      -moz-transition: 0.2s ease all;
      -webkit-transition: 0.2s ease all;
      width: 50%;
    }

    .rf-input-group > textarea:disabled {
      background: #fff;
      color: rgba(0, 0, 0, 0.65);
      cursor: not-allowed;
    }
</style>

<script>
  export default {
    name: 'RF-Text-Area',
    props: {
      cpntStatus: {
        required: true
      },
      cpntId: {
        required: true,
        type: String
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntValue: {
        required: true,
        type: [ String, Number ]
      },
      cpntAutoComplete: {
        type: String,
        required: false,
        default: 'off'
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntPlaceholder: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntMaxLength: {
        type: Number,
        required: false,
        default: function () {
          return 99999999
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntClassDivField: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return []
        }
      },
      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    data: function () {
      return {
        status: '',
        value: '',
        classCampo: []
      }
    },
    mounted: function () {
      this.iniciarCampo()
    },
    methods: {
      iniciarCampo: function () {
        // SETA O STATUS
        this.status = 'carregando'

        // RESETA AS CLASSES DO INPUT
        this.classCampo = []

        // SETA O VALOR DO INPU
        this.value = this.cpntValue

        // CHAMA FUNÇÃO PARA VERIFICAR SE O CAMPO TEM VALOR
        this.checarClassCampo()

        // ALTERA O STATUS
        this.status = ''
      },
      checarClassCampo: function () {
        // REMOVE AS CLASSES DE FOCUS
        this.classCampo = this.classCampo.filter(item => (item !== 'rf-input-focus-true' && item !== 'rf-input-focus-false'))

        // VERIFICA SE O VALOR FOI PREENCHIDO
        if (this.value !== '') {
          this.classCampo.push('rf-input-focus-true')
        } else {
          this.classCampo.push('rf-input-focus-false')
        }
      },
      onChangeValue: function () {
        if (this.cpntValue !== this.value) {
          // EMITE UM EVENTO PARA ATUALIZAR O COMPONENT PAI
          this.cpntOnChange(this.value, this.cpntId)
        }

        // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
        this.checarClassCampo()
      },
      onFocusField: function (scroll) {
        // CHAMA FUNÇÃO PARA DAR FOCUS E DAR SCROOL NA TELA
        this.$store.state.ON_FOCUS_CAMPO('RF-Text-Area', this.cpntId, scroll)
      }
    },
    watch: {
      'value': function () {
        if (this.cpntValue !== this.value) {
          this.onChangeValue()
        }
      },
      'cpntValue': function () {
        // SETA O VALOR DO INPU
        this.value = this.cpntValue

        // CHAMA FUNÇÃO PARA VERIFICAR SE O CAMPO TEM VALOR
        this.checarClassCampo()
      }
    }
  }
</script>
